/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_Delete_KeepsInputs */

const en_us2_coach_manage_delete_keeps = /** @type {(inputs: Coach_Manage_Delete_KeepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the trainer knows from your stored data stays: profile, plan and workout history.`)
};

const pt_br2_coach_manage_delete_keeps = /** @type {(inputs: Coach_Manage_Delete_KeepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que o personal sabe pelos seus dados salvos continua: perfil, plano e histórico de treinos.`)
};

const es_419_coach_manage_delete_keeps = /** @type {(inputs: Coach_Manage_Delete_KeepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que el entrenador sabe por tus datos guardados se mantiene: perfil, plan e historial de entrenamientos.`)
};

const pt_pt2_coach_manage_delete_keeps = /** @type {(inputs: Coach_Manage_Delete_KeepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que o treinador sabe pelos teus dados guardados mantém-se: perfil, plano e histórico de treinos.`)
};

const fr_fr2_coach_manage_delete_keeps = /** @type {(inputs: Coach_Manage_Delete_KeepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que le coach sait grâce à tes données enregistrées reste : profil, programme et historique des séances.`)
};

const de_de2_coach_manage_delete_keeps = /** @type {(inputs: Coach_Manage_Delete_KeepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was der Coach aus deinen gespeicherten Daten weiß, bleibt: Profil, Plan und Trainingsverlauf.`)
};

const it_it2_coach_manage_delete_keeps = /** @type {(inputs: Coach_Manage_Delete_KeepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quello che il coach sa dai tuoi dati salvati resta: profilo, scheda e storico degli allenamenti.`)
};

/**
* | output |
* | --- |
* | "What the trainer knows from your stored data stays: profile, plan and workout history." |
*
* @param {Coach_Manage_Delete_KeepsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_delete_keeps = /** @type {((inputs?: Coach_Manage_Delete_KeepsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Delete_KeepsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_delete_keeps(inputs)
	if (locale === "es-419") return es_419_coach_manage_delete_keeps(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_delete_keeps(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_delete_keeps(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_delete_keeps(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_delete_keeps(inputs)
	return en_us2_coach_manage_delete_keeps(inputs)
});
export { coach_manage_delete_keeps as "coach-manage.delete_keeps" }